import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { IBank, ICurrency, IMoneyAccount } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import Switch from '../../components/Inputs/Switch'
import { docs } from '../../userConfig'
import { addAccount } from '../../redux/actions/accounts'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import axios from 'axios'
const server = process.env.REACT_APP_SERVER_URL

const CreateAccountForm: React.FC<CreateAccountFormProps> = ({
  banks,
  currencies,
  accounts,
  onCancel,
}) => {
  const dispatch = useDispatch()
  const { addAlert } = useSnackBars()
  
  const currenciesFormatted = currencies?.map(v => ({text: v?.code === "VES" ? "BOLIVAR" : v?.name, value: v?.id+""}))

  const form = useForm()

  const [cashier, setCashier] = useState<any[]>([])

  const [accountType, setAccountType] = useState<{
    value: string
    text: string
  }>({
    value: 'national',
    text: 'Banco Nacional',
  })
  // const [showBankTransfer, setShowBankTransfer] = useState<boolean>(false)
  const [showPagoMovil, setShowPagoMovil] = useState<boolean>(false)
  const [showCardSwiper, setShowCardSwiper] = useState<boolean>(false)
  const [availableCurrencies] = useState<ICurrency[]>(() => {
    const available: ICurrency[] = []
    for (let i = 0; i < currencies.length; i++) {
      // let seem = false
      // for (let j = 0; j < accounts.length; j++) {
      //   if (
      //     accounts[j].currency.id === String(currencies[i].id) &&
      //     accounts[j].accountType === 'CASH'
      //   ) {
      //     seem = true
      //   }
      // }
      // if (!seem) available.push(currencies[i])
      available.push(currencies[i])
    }
    return available
  })

  // const [typeDocumentSelected, setTypeDocumentSelected] = useState<{
  //   value: number | string
  //   text: string
  // }>({
  //   value: 'V',
  //   text: 'V',
  // })

  const options: {
    value: string
    text: string
  }[] = [
      { value: 'BANK_ACCOUNT', text: 'Cuenta Bancaria' },
      { value: 'OTHER', text: 'Internacional / Otros' },
      { value: 'CASH', text: 'Efectivo' },
    ]

  const options_without_cash: {
    value: string
    text: string
  }[] = [
      { value: 'BANK ACCOUNT', text: 'Cuenta Bancaria' },
      { value: 'WALLET', text: 'Billetera Electrónica' },
    ]



  const handleSubmit = async (values) => {
    // console.log('values', values)

    let selectedCashier = cashier.find(val => val.id === values.idCashier)

    let id = ""

    try {
      addAlert({
        message: 'Creando cuenta...',
        status: 'loading',
      })
      const basic_account: Omit<IMoneyAccount, 'accountType'> = {
        // id: String(Math.floor(Math.random() * 1000)),
        id: '0',
        balance: '0.00',
        currency: {
          id: values.currency,
          // name:
          //   currencies.find((curr) => curr.id === values.currency)?.name ||
          //   'no encontrado',
          // abbr:
          //   currencies.find((curr) => curr.id === values.currency)?.code ||
          //   'no encontrado',
        },
        accountVisible: false,
      }

      if (values.type === 'CASH') {
        const new_cash_account: IMoneyAccount = {
          ...basic_account,
          accountType: 'CASH',
          description: values.description,
        }
        // console.log('adding cash: ', new_cash_account)
        let response : any = await dispatch(addAccount(new_cash_account))

        id = response.data.account.id

        // await axios.patch(`${server}/cashier`, {id: selectedCashier?.id, idPosAccount: response.data.account.id, name: selectedCashier?.name})


      }
      if (values.type === 'BANK_ACCOUNT') {
        if (
          !values.account_number &&
          !values.phone &&
          !values.cardSwiperNumber
        ) {
          addAlert({
            message: 'Debe especificar al menos un método de pago',
            status: 'error',
          })
          return
        }
        const new_bank_account: IMoneyAccount = {
          ...basic_account,
          accountType: 'BANK_ACCOUNT',
          document: {
            documentType: values.document.documentType,
            document: values.document.document,
          },
          bank: {
            id: values.bank,
          },
          description: values.description,
          owner: values.owner_name,
          bankAccountType: values.bank_account_type || 'CHECKING',
          bankAccountNumber: values.account_number ? values.account_number : '',
          mobilePaymentPhone: values.phone ? values.phone : '',
          cardSwiperNumber: values.cardSwiperNumber
            ? values.cardSwiperNumber
            : '',
        }
        // console.log('adding bank account: ', new_bank_account)
        let response : any = await dispatch(addAccount(new_bank_account))

        id = response.data.account.id
        // await axios.patch(`${server}/cashier`, {id: selectedCashier?.id, idPosAccount: response.data.account.id, name: selectedCashier?.name})
      }

      if (values.type === 'OTHER') {
        const new_wallet_account: IMoneyAccount = {
          ...basic_account,
          owner: values.owner_name,
          accountType: 'OTHER',
          accountNumber: values.wallet_name,
          description: values.description,
        }
        // console.log('creating wallet: ', new_wallet_account)
        let response : any = await dispatch(addAccount(new_wallet_account))

        id = response.data.account.id
      }
      
      if (selectedCashier) {
        await axios.patch(`${server}/cashier`, {id: selectedCashier?.id, idPosAccount: id, name: selectedCashier?.name})
      }

      addAlert({
        message: 'Cuenta creada con éxito',
        status: 'success',
      })
      onCancel()
    } catch (error: any) {
      addAlert({
        message:
          error.response?.data?.message || 'Error al crear cuenta bancaria',
        status: 'error',
      })
    }
  }

  const getCashier = async () => {
    let response = await axios.get(`${server}/cashier`)
    setCashier(response.data.cashiers)
  }

  useEffect(() => {
    getCashier()
  }, [])
  

  return (
    <Form
      form={form}
      onSubmit={(values) => handleSubmit(values)}
      classes={`gap-x-6 gap-y-2`}
      style={{ width: '100%' }}
    >
      <h2 className="col-span-12 mt-1 text-primary-900 font-bold dark:text-white">
        Añadir Cuenta
      </h2>
      <FormItem
        name="type"
        rules={{ required: 'Es necesario el campo' }}
        defaultValue={options[0]}
        classes="xl:col-span-3 col-span-12"
      >
        <Select
          options={
            availableCurrencies.length > 0 ? options : options_without_cash
          }
          label="Tipo de Cuenta"
          setSelectedHelper={setAccountType}
        />
      </FormItem>

      {accountType.value === 'CASH' && (
        <>
          <FormItem
            name="currency"
            classes="xl:col-span-4 col-span-12"
            defaultValue={{
              value: currenciesFormatted[0].value,
              text: currenciesFormatted[0].text,
            }}
          >
            <Select
              options={currenciesFormatted}
              label="Moneda"
            // setSelectedHelper={setBan}
            />
          </FormItem>

          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Nombre de la cuenta"
              placeholder="Ingresar datos de la cuenta"
              maxLength={255}
            />
          </FormItem>
        </>
      )}

      {accountType.value === 'OTHER' && (
        <>
          <FormItem
            name="owner_name"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-4 col-span-12"
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          <FormItem
            name="wallet_name"
            classes="xl:col-span-4 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <InputText small label="Nro. Cuenta / Coordenada" maxLength={255} />
          </FormItem>

          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Nombre de la cuenta"
              placeholder="Ingresar el nombre de la cuenta"
              maxLength={255}
            />
          </FormItem>
          <FormItem
            name="currency"
            classes="xl:col-span-6 col-span-12"
            defaultValue={{
              value: currencies[1].id,
              text: currencies[1].name,
            }}
          >
            <Select
              options={currencies
                .filter((c) => String(c.id) !== '2')
                .map((curr) => ({
                  value: curr.id,
                  text: curr.name,
                }))}
              label="Moneda"
            // setSelectedHelper={setBan}
            />
          </FormItem>
        </>
      )}

      {accountType.value === 'BANK_ACCOUNT' && (
        <>
          <FormItem
            name="bank"
            classes="xl:col-span-4 col-span-12"
            defaultValue={{
              value: banks[0]?.id,
              text: banks[0]?.name,
            }}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.id,
                text: bank.name,
              }))}
              label="Banco"
            // setSelectedHelper={setBan}
            />
          </FormItem>

          <FormItem
            name="description"
            rules={{ required: 'Ingresar el nombre de la cuenta' }}
            classes="xl:col-span-5 col-span-12"
          >
            <InputText small label="Nombre de la cuenta" maxLength={255} />
          </FormItem>

          <FormItem
            defaultValue={docs[0]}
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
          >
            <Select
              options={docs}
              label="Tipo"
            // setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            name="document.document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="owner_name"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          <FormItem
            name="currency"
            classes="xl:col-span-5 col-span-12"
            defaultValue={{
              value: currencies[1].id,
              text: currencies[1].name,
            }}
          >
            <Select
              options={currenciesFormatted}
              label="Moneda"
            // setSelectedHelper={setBan}
            />
          </FormItem>

          <FormItem
            defaultValue={bankAccountType[0]}
            name="bank_account_type"
            classes="xl:col-span-3 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <Select options={bankAccountType} label="Tipo de cuenta" />
          </FormItem>

          <FormItem
            name="account_number"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesaria un número de cuenta'
            }}
          >
            <InputText
              small
              phone={true}
              label="Número de cuenta"
            />
          </FormItem>

          <h3 className="col-span-12 my-1 text-primary-900 font-bold dark:text-white">
            Métodos de Pago
          </h3>

          {/* <div className="xl:col-span-4 col-span-12 flex flex-col"> */}
            {/* <Switch
              label="Transferencia"
              small={true}
              onChange={setShowBankTransfer}
              containerClasses="mb-2"
            ></Switch> */}

            {/* {showBankTransfer && ( */}

            {/* )} */}
          {/* </div> */}

          <div className="xl:col-span-6 col-span-12 flex flex-col">
            <Switch
              label="Pago Móvil"
              small={true}
              onChange={setShowPagoMovil}
              containerClasses="mb-2"
              forForm={true}
            ></Switch>

            {showPagoMovil && (
              <FormItem
                name="phone"
                classes="xl:w-1/2 w-full"
                rules={{
                  // pattern: {
                  //   value: phoneNumberRegex,
                  //   message: 'El número telefónico ingresado debe ser válido',
                  // },
                  required: true,
                }}
              >
                <InputText
                  isUpperValue={false}
                  small
                  label="Teléfono"
                  maxLength={255}
                />
              </FormItem>
            )}
          </div>

          <div className="xl:col-span-6 col-span-12 flex flex-col">
            <Switch
              label="Punto de Venta"
              small={true}
              onChange={setShowCardSwiper}
              containerClasses="mb-2"
              forForm={true}
            ></Switch>

            {showCardSwiper && (

              <div className='flex'>
              <FormItem
                name="cardSwiperNumber"
                classes="xl:w-1/2 w-full"
                rules={{
                  required: true,
                }}
              >
                <InputText
                  isUpperValue={false}
                  small
                  label="Serial"
                  maxLength={255}
                />
              </FormItem>

              <FormItem
                name="idCashier"
                classes="xl:w-1/2 w-full"
                rules={{
                  required: true,
                }}
                defaultValue={{
                  text: cashier[0].name,
                  value: cashier[0].id
                }}
              >
                <Select options={cashier.map(v => ({
                  text: v.name,
                  value: v.id
                }))} 
                 label='Cajero' />
              </FormItem>
              </div>
            )}
          </div>
        </>
      )}

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              onCancel()
              console.log('cancel')
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button type="primary" classes="w-full" htmlType="submit">
            Añadir
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface CreateAccountFormProps {
  banks: IBank[]
  currencies: ICurrency[]
  accounts: IMoneyAccount[]
  onCancel: Function
}

export default CreateAccountForm

export const bankAccountType = [
  {
    value: 'SAVING',
    text: 'Ahorro',
  },
  {
    value: 'CHECKING',
    text: 'Corriente',
  },
]